<template>
    <main-layout>
        <template #submenu>
            <helm-chart-sub-menu :team="team" :chart="chart" active="templates"></helm-chart-sub-menu>
        </template>

        <template #pageTitle>
            <h2 class="mb-1">
                <span>Helm Chart Settings</span>
                <span>{{team.slug}}</span> /
                <span>{{chart.chart_name}}</span>
            </h2>
            <span class="sm-text">Corporate website of the '{{ team.slug }}' company</span>
        </template>

        helm chart template files display here
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import HelmChartSubMenu from "@/Components/HelmChartSubMenu";
    export default {
        name: "Templates",
        components: {HelmChartSubMenu, MainLayout},
        props: ['team', 'chart']
    }
</script>

<style scoped>

</style>
